import React from "react";

export default function FiltersIcon(props) {
  const { size } = props;
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.13 4.721c0-.927.752-1.678 1.68-1.678h14.469c.927 0 1.678.751 1.678 1.678v.895a2.52 2.52 0 0 1-.677 1.718l-5.11 5.475a1.68 1.68 0 0 0-.452 1.146v3.722a.84.84 0 0 1-.464.75l-3.67 1.835a.84.84 0 0 1-1.214-.75v-5.558c0-.425-.161-.834-.451-1.145L3.808 7.334a2.517 2.517 0 0 1-.677-1.718V4.72Z"
        fill="currentColor"
      />
    </svg>
  );
}
